import { color } from '@/theme/tokens';
import { typography } from '@/theme/typography';
import styled from '@emotion/styled';

const ContractAgreementPreview = styled.div`
    font-family: var(--font-noto-sans), Helvetica, Arial, sans-serif;
    max-width: 100%;

    * {
        font-family: inherit;
    }

    img {
        max-width: 100%;
        height: auto;
    }

    table {
        max-width: 100%;
    }

    p {
        font-size: ${typography.paragraph4regular.fontSize} !important;
        line-height: ${typography.paragraph4regular.lineHeight} !important;
        letter-spacing: ${typography.paragraph4regular.letterSpacing}px !important;
    }

    a {
        color: ${color.brand[50]} !important;
    }

    tr td p {
        font-size: 12px !important;
    }

    /* Explicitly preserve native ol numbering so the start attribute works */
    ol {
        list-style-type: decimal !important;
        padding-left: 24px;
    }

    /* Second level ordered lists use alphabetical markers */
    ol.lexical-ol2 {
        list-style-type: lower-alpha !important;
    }

    /* Third level ordered lists use roman numerals */
    ol.lexical-ol3 {
        list-style-type: lower-roman !important;
    }

    /* Hide marker for list items that only contain nested lists */
    li.lexical-nested-listitem {
        list-style-type: none !important;
    }

    ol li::before {
        content: none !important;
    }
`;

export default ContractAgreementPreview;
